import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="chigua-container py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <h4 className="text-xl font-heading font-bold text-background-50 mb-4">
              {siteInfo.name}
            </h4>
            <p className="text-sm text-background-400 leading-relaxed max-w-md">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h5 className="text-sm font-heading font-bold text-background-50 mb-4">
              内容分类
            </h5>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h5 className="text-sm font-heading font-bold text-background-50 mb-4">
              关于我们
            </h5>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                品牌介绍
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                联系我们
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">
                常见问题
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="chigua-container py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供娱乐参考，如有不实之处请联系我们修正
          </p>
        </div>
      </div>
    </footer>
  );
}